// extracted by mini-css-extract-plugin
export default {"main":"Status_main__hMRln","title":"Status_title__tPNgI","value":"Status_value__seewH"};